import React from "react";
import { Link } from "react-router-dom";

const BalanceMinutesSellSuccess: React.FC = () => {
    return (
        <div className="card border-success mb-3">
            <div className="card-body text-success">
                <h5 className="card-title">Sale Created</h5>
                <p className="card-text">
                    Your sale will executed in the order it was created to the
                    highest price buy request.
                </p>
                <Link
                    className="btn btn-outline-success"
                    to="/home/dashboard/balance/minutes/sales-record"
                >
                    View All Sales
                </Link>
            </div>
        </div>
    );
};

export default BalanceMinutesSellSuccess;
